<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_Gcs_Field_Key')"
        :hint="$t('Integrations_Gcs_Field_Key_Hint')"
        prop="params.key"
      >
        <el-input
          v-model="model.params.key"
          type="textarea"
          :placeholder="keyPlaceholder"
          :rows="10"
        />
      </rest-form-item>

      <el-row>
        <el-col :span="12">
          <rest-form-item
            :label="$t('Integrations_Gcs_Field_Bucket')"
            prop="params.bucket"
          >
            <el-input
              v-model="model.params.bucket"
              :placeholder="$t('Integrations_Gcs_Field_Bucket_Placeholder')"
            />
          </rest-form-item>
        </el-col>

        <el-col :span="12">
          <rest-form-item
            :label="$t('Integrations_Gcs_Field_Folder')"
            prop="params.folder"
          >
            <el-input
              v-model="model.params.folder"
              :placeholder="$t('Integrations_Gcs_Field_Folder_Placeholder')"
            />
          </rest-form-item>
        </el-col>
      </el-row>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'GcsSettings',

  components: {
    FormSection,
    RestFormItem
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      keyPlaceholder: '{\n    "type":"service_account",\n    ...\n}',

      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          key: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          bucket: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/gcs/GcsSettings.vue